/**
 * Polyfill for requestIdleCallback (Safari compatibility)
 * Safari doesn't support requestIdleCallback, so we provide a setTimeout fallback
 */
const requestIdleCallbackPolyfill = (callback: (deadline?: any) => void, options?: { timeout?: number }) => {
  const timeout = options?.timeout || 0
  return setTimeout(() => {
    const start = performance.now()
    callback({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (performance.now() - start)),
    })
  }, timeout)
}

const cancelIdleCallbackPolyfill = (id: number) => {
  clearTimeout(id)
}

/**
 * Cross-browser safe requestIdleCallback
 * Uses native implementation when available, falls back to setTimeout polyfill
 */
export const safeRequestIdleCallback =
  typeof requestIdleCallback !== 'undefined' ? requestIdleCallback : requestIdleCallbackPolyfill

/**
 * Cross-browser safe cancelIdleCallback
 * Uses native implementation when available, falls back to clearTimeout polyfill
 */
export const safeCancelIdleCallback =
  typeof cancelIdleCallback !== 'undefined' ? cancelIdleCallback : cancelIdleCallbackPolyfill
